import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/';
import { AlertService, AreaSectorOfBusinessService, AppService } from '../_services/index';
import {NgbModal, NgbActiveModal,NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

class AreaSectorOfBusiness {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: 'app-area-sector-of-business',
  templateUrl: './area-sector-of-business.component.html',
  styles: []
})

export class AreaSectorOfBusinessComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; //  DataTable
    dtTrigger = new Subject(); //  DataTable
    areaSectorOfBusinessList: AreaSectorOfBusiness[] = []; // Table Data list
    isSubmitted = false;
    getAreaSectorOfBusiness = {
      id:'',
      name: '',
      description: '',
      is_active: 'N'
    };
    modalReference:NgbActiveModal;
    modalTitle:string;

    constructor(
                public router: Router,
                private dataService:AreaSectorOfBusinessService,
                private alertService: AlertService,
                private AppService: AppService,
                private modalService: NgbModal
               ) { }

    areasectorofbusiness = {
      id:'',
      name: '',      
      description: '',
      is_active: 'Y'
    };
    showloding = true;
    lodingImage = false;


    ngOnInit() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.allAreaSectorOfBusiness();
    }
  
    allAreaSectorOfBusiness(){
      this.loadShow();
      this.dataService.getAllAreaSectorOfBusiness()
          .pipe().subscribe(data => { 
            this.areaSectorOfBusinessList = data['AreaSectorOfBusiness']; 
            this.dtTrigger.next(); // Data Table
            this.loadHide();
          });
       }
  
    open(content) {
      this.isSubmitted = false;
      this.areasectorofbusiness.id='';
      this.areasectorofbusiness.name = '',
      this.areasectorofbusiness.description = '',
      this.areasectorofbusiness.is_active = 'Y';
      this.modalTitle = "Add Area Sector Of Business";
      this.modalReference = this.modalService.open(content);
    }
  
    edit(id,content){
      this.loadShow();
      this.dataService.areaSectorOfBusinessEdit(id)
          .pipe().subscribe(data => { 
                  this.getAreaSectorOfBusiness = data['AreaSectorOfBusiness']; 
                  this.areasectorofbusiness = {
                        id:this.getAreaSectorOfBusiness.id,
                        name:this.getAreaSectorOfBusiness.name,                        
                        description:this.getAreaSectorOfBusiness.description,
                        is_active:this.getAreaSectorOfBusiness.is_active
                  };
                  this.loadHide();
                  this.modalTitle = "Edit Area Sector Of Business";
                  this.modalReference = this.modalService.open(content);
               });
           }

  
    save(val,f){
      this.isSubmitted = true;
      if(f.form.valid) {
        this.loadShow()
        if(val.id == ''){
          this.dataService.save(this.areasectorofbusiness)
              .pipe().subscribe(data =>{
                this.loadHide()
                this.modalReference.close();
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Area sector of business saved successfully', true);
                this.allAreaSectorOfBusiness();
              },error =>{
                this.loadHide()
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
        }else{
          this.dataService.areaSectorOfBusinessUpdate(this.areasectorofbusiness)
              .pipe().subscribe(data =>{
                this.loadHide()
                this.modalReference.close();
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Area sector of business updated successfully', true);
                this.allAreaSectorOfBusiness();
              },error =>{
                this.loadHide()
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
            }
          }
       }
  
    delete(id){
      if(confirm("Are you sure to delete")) {
        this.dataService.areaSectorOfBusinessDelete(id)
            .pipe().subscribe(data =>{
              if(data['status']==200){
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Area sector of business deleted successfully', true);
                this.allAreaSectorOfBusiness();
              }else{
                this.alertService.error('AreaSectorOfBusiness error');
              }
            },error =>{
              this.alertService.error(error);
            });
          }
        }
  
    loadShow(){
      this.showloding = true;
      this.lodingImage = false;
   }
  
    loadHide(){
      this.showloding = false;
      this.lodingImage = true;
    }

}
